import { Flow_0_0_2 } from '@flexus/core';

export const SIL_84: Flow_0_0_2 = {
	id: '84',
	name: 'quote_submitted_tl',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for server decision'
		}
	},
	startNode: '',
	nodes: {}
};
